export default function Spinner({ label }: { label?: string }) {
  return (
    <div className="spinner-wrap" role="status" aria-live="polite">
      <div className="spinner" />
      {label ? <span className="muted">{label}</span> : null}
    </div>
  );
}
